import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "./notification.hook";
import CollaboratorsHistoryApprovalFlowService from "../services/api/collaborators/CollaboratorsHistoryApprovalFlow.service";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../constants/Dictionary";

export const useConfirmApprovePersonalProfile = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({
      profileId,
      isMyProfile,
    }: {
      profileId: number;
      isMyProfile: boolean;
    }) => {
      if (isMyProfile) {
        return await CollaboratorsHistoryApprovalFlowService.submitDrafItemsToCM(
          profileId,
        );
      } else {
        return await CollaboratorsHistoryApprovalFlowService.approveAllPendingItems(
          profileId,
        );
      }
    },
    onSuccess: (_, { profileId }) => {
      const keys = [
        `get-collaborator-history-professional-experience-${profileId}`,
        `get-collaborator-history-languages-${profileId}`,
        `get-collaborator-history-tech-skills-${profileId}`,
        `get-collaborator-history-educations-${profileId}`,
        `get-collaborator-history-courses-${profileId}`,
        `get-collaborator-history-certifications-${profileId}`,
        `get-collaborator-history-projects-${profileId}`,
      ];
      keys.forEach((key) => {
        queryClient.invalidateQueries({ queryKey: [key] });
      });
    },
    onError: (error) => {
      console.error(`${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutateAsync, isPending };
};
